import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_COMPONENTES_SERIE,
  SAVE_COMPONENTES_SERIE,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER
} from 'constants/ActionTypes';
import {
  getComponentesSerieSuccess,
  saveComponentesSerieSuccess
} from 'actions/ComponentesSerie';
import { showMessage, showSuccessMessage } from 'actions/SeriesEscola';
import requisicaoApi from 'util/Api';

function* getComponentesSerie({ payload }) {
  try {
    const { escolaId, cursoId, serieId } = payload;
    const response = yield call(requisicaoApi.get, `/componentes-serie/curso/${cursoId}/serie/${serieId}`);
    
    if (response.status === 200) {
      const data = response.data;
      let resultado = data;
      
      if (Array.isArray(data)) {
        resultado = data.length > 0 ? data[0] : null;
      }
      
      yield put(getComponentesSerieSuccess(resultado));
    }
  } catch (error) {
    console.error('Erro ao buscar componentes da série:', error);
    if (error.response && error.response.status === 404) {
        yield put(getComponentesSerieSuccess(null));
    } else {
        yield put(showMessage('seriesEscola.erroBuscarComponentes'));
        yield put({ type: ON_HIDE_LOADER });
    }
  }
}

function* saveComponentesSerie({ payload }) {
  try {
    yield put({ type: ON_SHOW_LOADER });
    
    // Se tem ID > 0, é PUT, senão POST
    // O payload de exemplo tem "id": 0 para criação.
    const method = (payload.id && payload.id > 0) ? 'put' : 'post';
    const url = (payload.id && payload.id > 0) ? `/componentes-serie/${payload.id}` : '/componentes-serie';
    
    const response = yield call(requisicaoApi[method], url, payload);
    
    if (response.status === 200 || response.status === 201) {
      yield put(saveComponentesSerieSuccess(response.data));
      yield put(showSuccessMessage('seriesEscola.sucessoComponentes'));
    } else {
      yield put(showMessage('seriesEscola.erroComponentes'));
    }
  } catch (error) {
    console.error('Erro ao salvar componentes da série:', error);
    
    let mensagemErro = 'seriesEscola.erroComponentes';
    const response = error.response;

    if (response && response.data) {
        const data = response.data;
        if (Array.isArray(data.inconsistencias) && data.inconsistencias.length > 0) {
            mensagemErro = data.inconsistencias[0].mensagem;
        } else if (data.mensagem) {
            mensagemErro = data.mensagem;
        }
    }
    
    yield put(showMessage(mensagemErro));
  } finally {
    yield put({ type: ON_HIDE_LOADER });
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(GET_COMPONENTES_SERIE, getComponentesSerie),
    takeEvery(SAVE_COMPONENTES_SERIE, saveComponentesSerie),
  ]);
}
